const TabTypes = {
  policies: 'policies',
  absenceTypes: 'absence-types',
  approvalGroups: 'approval-groups',
  blockedPeriods: 'blocked-periods',
}

export { TabTypes }
